export interface ChapterItem {
  no: string;
  arc: string;
  title: string;
  status: "已收录" | "更新中" | "完结";
}

export const chapterStats = {
  total: "主篇逾200话",
  covered: "180+",
  stage: "主线已至完结篇",
  update: "定期追更整理",
};

export const chapters: ChapterItem[] = [
  { no: "第1话", arc: "双生武魂 · 觉醒", title: "唐门重生，武魂觉醒", status: "已收录" },
  { no: "第12话", arc: "双生武魂 · 觉醒", title: "蓝银草与昊天锤", status: "已收录" },
  { no: "第25话", arc: "史莱克学院", title: "七怪首度聚首", status: "已收录" },
  { no: "第41话", arc: "史莱克学院", title: "学院的铁则与历练", status: "已收录" },
  { no: "第58话", arc: "魂师大赛", title: "大赛开幕，初露锋芒", status: "已收录" },
  { no: "第79话", arc: "魂师大赛", title: "巅峰对决，扬名大陆", status: "已收录" },
  { no: "第104话", arc: "海神岛", title: "远赴海神岛", status: "已收录" },
  { no: "第132话", arc: "海神岛", title: "海神九考 · 生死磨砺", status: "已收录" },
  { no: "第158话", arc: "武魂殿", title: "武魂殿的阴影", status: "已收录" },
  { no: "第176话", arc: "武魂殿", title: "决战前夕，群雄聚首", status: "已收录" },
  { no: "第192话", arc: "最终决战", title: "殊死一搏，逆转战局", status: "已收录" },
  { no: "第206话", arc: "成神 · 大结局", title: "海神之位，圆满落幕", status: "完结" },
];

export const arcProgress = [
  { name: "双生武魂 · 觉醒", percent: 100 },
  { name: "史莱克学院", percent: 100 },
  { name: "魂师大赛", percent: 100 },
  { name: "海神岛 · 九考", percent: 100 },
  { name: "武魂殿 · 决战", percent: 100 },
  { name: "成神 · 大结局", percent: 100 },
];